import { STRIPE_ERROR_CODES } from 'payments/constants/stripe';

export const getStripeErrorSnackbarArgs = (errorCode: string) => {
  let key: string, message: string;

  switch (errorCode) {
    case STRIPE_ERROR_CODES.INCOMPLETE_CVC:
    case STRIPE_ERROR_CODES.INCOMPLETE_EXPIRY:
    case STRIPE_ERROR_CODES.INCOMPLETE_NUMBER:
    case STRIPE_ERROR_CODES.INVALID_EXPIRY_YEAR_PAST:
    case STRIPE_ERROR_CODES.INVALID_NUMBER:
      key = 'STRIPE_CARD_FIELD_ERROR_SNACKBAR';
      message = 'Please update the indicated fields.';
      break;
    case STRIPE_ERROR_CODES.CARD_DECLINED:
      key = 'STRIPE_CARD_DECLINED_ERROR_SNACKBAR';
      message = 'The card has been declined.';
      break;
    case STRIPE_ERROR_CODES.TESTMODE_CHARGES_ONLY:
      key = 'STRIPE_TESTMODE_CHARGES_ONLY_ERROR_SNACKBAR';
      message =
        'Your account has not been activated and can only make test charges.';
      break;
    default:
      key = 'STRIPE_CREATE_TOKEN_ERROR_SNACKBAR';
      message = 'Something went wrong generating the Stripe token';
  }

  return {
    key,
    message
  };
};
